import { Nullable } from '../types'
import { Messenger } from './messenger'

export const messengerRef: { current: Nullable<Messenger> } = { current: null }
